
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */
// biome-ignore-all lint: generated file

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  DbNull,
  JsonNull,
  AnyNull,
  NullTypes,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 7.0.1
 * Query Engine version: f09f2815f091dbba658cdcd2264306d88bb5bda6
 */
Prisma.prismaVersion = {
  client: "7.0.1",
  engine: "f09f2815f091dbba658cdcd2264306d88bb5bda6"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = DbNull
Prisma.JsonNull = JsonNull
Prisma.AnyNull = AnyNull

Prisma.NullTypes = NullTypes



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  emailVerified: 'emailVerified',
  password: 'password',
  name: 'name',
  company: 'company',
  website: 'website',
  role: 'role',
  image: 'image',
  twoFactorEnabled: 'twoFactorEnabled',
  twoFactorSecret: 'twoFactorSecret',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires',
  userAgent: 'userAgent',
  ipAddress: 'ipAddress',
  location: 'location',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.PasswordResetTokenScalarFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token',
  expires: 'expires',
  createdAt: 'createdAt'
};

exports.Prisma.CreditScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  balance: 'balance',
  totalPurchased: 'totalPurchased',
  totalUsed: 'totalUsed',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CreditTransactionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  amount: 'amount',
  type: 'type',
  description: 'description',
  cryptoPaymentId: 'cryptoPaymentId',
  createdAt: 'createdAt'
};

exports.Prisma.CryptoWalletScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  currency: 'currency',
  address: 'address',
  createdAt: 'createdAt',
  derivationIndex: 'derivationIndex',
  lastCheckedBlock: 'lastCheckedBlock',
  network: 'network',
  sweepLocked: 'sweepLocked',
  sweepLockedAt: 'sweepLockedAt'
};

exports.Prisma.CryptoBalanceScalarFieldEnum = {
  id: 'id',
  walletId: 'walletId',
  userId: 'userId',
  currency: 'currency',
  network: 'network',
  availableAmount: 'availableAmount',
  totalDeposited: 'totalDeposited',
  totalSwept: 'totalSwept',
  totalSpent: 'totalSpent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CryptoBalanceTransactionScalarFieldEnum = {
  id: 'id',
  balanceId: 'balanceId',
  walletId: 'walletId',
  userId: 'userId',
  currency: 'currency',
  network: 'network',
  type: 'type',
  amount: 'amount',
  balanceBefore: 'balanceBefore',
  balanceAfter: 'balanceAfter',
  txHash: 'txHash',
  relatedId: 'relatedId',
  description: 'description',
  metadata: 'metadata',
  createdAt: 'createdAt'
};

exports.Prisma.CryptoPaymentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  currency: 'currency',
  amountCrypto: 'amountCrypto',
  amountUsd: 'amountUsd',
  creditsPurchased: 'creditsPurchased',
  walletAddress: 'walletAddress',
  transactionHash: 'transactionHash',
  status: 'status',
  confirmations: 'confirmations',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  confirmedAt: 'confirmedAt',
  cancelledAt: 'cancelledAt',
  expiresAt: 'expiresAt',
  network: 'network'
};

exports.Prisma.SweepTransactionScalarFieldEnum = {
  id: 'id',
  walletId: 'walletId',
  userId: 'userId',
  currency: 'currency',
  network: 'network',
  amount: 'amount',
  txHash: 'txHash',
  treasuryAddress: 'treasuryAddress',
  feeAmount: 'feeAmount',
  status: 'status',
  errorMessage: 'errorMessage',
  createdAt: 'createdAt',
  completedAt: 'completedAt'
};

exports.Prisma.ExtractionTaskScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  jobId: 'jobId',
  urls: 'urls',
  dataTypes: 'dataTypes',
  status: 'status',
  progress: 'progress',
  creditsCost: 'creditsCost',
  webhookUrl: 'webhookUrl',
  autoValidate: 'autoValidate',
  maxDepth: 'maxDepth',
  maxUrls: 'maxUrls',
  scrapeExternal: 'scrapeExternal',
  stats: 'stats',
  errorMessage: 'errorMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  contactsFile: 'contactsFile',
  costBreakdown: 'costBreakdown',
  revalidationCostTokens: 'revalidationCostTokens',
  revalidationCostUsd: 'revalidationCostUsd',
  validationCostTokens: 'validationCostTokens',
  validationCostUsd: 'validationCostUsd',
  validationStatus: 'validationStatus'
};

exports.Prisma.ContactScalarFieldEnum = {
  id: 'id',
  taskId: 'taskId',
  userId: 'userId',
  type: 'type',
  value: 'value',
  source: 'source',
  verified: 'verified',
  tags: 'tags',
  socialPlatform: 'socialPlatform',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  validationDetails: 'validationDetails',
  validationTaskId: 'validationTaskId'
};

exports.Prisma.ValidationTaskScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  validationJobId: 'validationJobId',
  emails: 'emails',
  phones: 'phones',
  status: 'status',
  creditsCost: 'creditsCost',
  webhookUrl: 'webhookUrl',
  costBreakdown: 'costBreakdown',
  totalCostUsd: 'totalCostUsd',
  totalCostTokens: 'totalCostTokens',
  errorMessage: 'errorMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  startedAt: 'startedAt',
  completedAt: 'completedAt'
};

exports.Prisma.ApiKeyScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  keyHash: 'keyHash',
  keyPrefix: 'keyPrefix',
  lastUsedAt: 'lastUsedAt',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt'
};

exports.Prisma.TeamMemberScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  memberEmail: 'memberEmail',
  role: 'role',
  status: 'status',
  invitedAt: 'invitedAt',
  joinedAt: 'joinedAt'
};

exports.Prisma.SupportTicketScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  ticketNumber: 'ticketNumber',
  subject: 'subject',
  message: 'message',
  status: 'status',
  priority: 'priority',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  title: 'title',
  message: 'message',
  priority: 'priority',
  read: 'read',
  data: 'data',
  createdAt: 'createdAt'
};

exports.Prisma.UserPreferencesScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  emailNotifications: 'emailNotifications',
  extractionComplete: 'extractionComplete',
  paymentConfirmation: 'paymentConfirmation',
  weeklyReport: 'weeklyReport',
  marketingEmails: 'marketingEmails',
  securityAlerts: 'securityAlerts',
  creditLowAlert: 'creditLowAlert',
  newFeatures: 'newFeatures',
  dataRetentionDays: 'dataRetentionDays',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.Role = exports.$Enums.Role = {
  USER: 'USER',
  ADMIN: 'ADMIN'
};

exports.TransactionType = exports.$Enums.TransactionType = {
  PURCHASE: 'PURCHASE',
  USAGE: 'USAGE',
  REFUND: 'REFUND',
  BONUS: 'BONUS'
};

exports.CryptoCurrency = exports.$Enums.CryptoCurrency = {
  BTC: 'BTC',
  ETH: 'ETH',
  USDT: 'USDT',
  USDC: 'USDC'
};

exports.CryptoTransactionType = exports.$Enums.CryptoTransactionType = {
  DEPOSIT: 'DEPOSIT',
  SWEEP: 'SWEEP',
  SPEND: 'SPEND',
  REFUND: 'REFUND',
  ADJUSTMENT: 'ADJUSTMENT'
};

exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  FAILED: 'FAILED',
  EXPIRED: 'EXPIRED',
  CONFIRMING: 'CONFIRMING',
  CANCELLED: 'CANCELLED'
};

exports.SweepStatus = exports.$Enums.SweepStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.JobStatus = exports.$Enums.JobStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
};

exports.ContactType = exports.$Enums.ContactType = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  SOCIAL: 'SOCIAL'
};

exports.ValidationStatus = exports.$Enums.ValidationStatus = {
  PENDING: 'PENDING',
  VALIDATING: 'VALIDATING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.TeamRole = exports.$Enums.TeamRole = {
  VIEWER: 'VIEWER',
  EDITOR: 'EDITOR',
  ADMIN: 'ADMIN'
};

exports.MemberStatus = exports.$Enums.MemberStatus = {
  INVITED: 'INVITED',
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED'
};

exports.TicketStatus = exports.$Enums.TicketStatus = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED'
};

exports.TicketPriority = exports.$Enums.TicketPriority = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  URGENT: 'URGENT'
};

exports.NotificationType = exports.$Enums.NotificationType = {
  TASK_COMPLETE: 'TASK_COMPLETE',
  LOW_CREDITS: 'LOW_CREDITS',
  CRYPTO_DEPOSIT: 'CRYPTO_DEPOSIT',
  SYSTEM: 'SYSTEM',
  CREDIT_PURCHASE: 'CREDIT_PURCHASE'
};

exports.NotificationPriority = exports.$Enums.NotificationPriority = {
  NORMAL: 'NORMAL',
  IMPORTANT: 'IMPORTANT'
};

exports.Prisma.ModelName = {
  User: 'User',
  Account: 'Account',
  Session: 'Session',
  VerificationToken: 'VerificationToken',
  PasswordResetToken: 'PasswordResetToken',
  Credit: 'Credit',
  CreditTransaction: 'CreditTransaction',
  CryptoWallet: 'CryptoWallet',
  CryptoBalance: 'CryptoBalance',
  CryptoBalanceTransaction: 'CryptoBalanceTransaction',
  CryptoPayment: 'CryptoPayment',
  SweepTransaction: 'SweepTransaction',
  ExtractionTask: 'ExtractionTask',
  Contact: 'Contact',
  ValidationTask: 'ValidationTask',
  ApiKey: 'ApiKey',
  TeamMember: 'TeamMember',
  SupportTicket: 'SupportTicket',
  Notification: 'Notification',
  UserPreferences: 'UserPreferences'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
